module.exports = __webpack_public_path__ + "img/arrow-back-used.840b6436.svg";